export default "__VITE_ASSET__RTzuIxwx__"